import React, {useEffect, useRef} from 'react'
import moment from 'moment'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMap from 'highcharts/modules/map'
import { useHistory } from 'react-router-dom'
import usStateDummy from './dummyStats'
import { useGeoState } from '../GeoProvider'
import Spinner from '../Loader/Spinner'

import getMapOptions from './getMapOptions'
import dayjs from 'dayjs'
import CountingMethod from './../../utils/getCountingMethod'
import * as Exporting from 'highcharts/modules/exporting'
import * as OfflineExport from 'highcharts/modules/offline-exporting'

const Map = ({
  toolTipFormatter,
  activeCbsasData,
  statesData,
  cbsaData,
  msaData,
  mapOptions,
  vulStateData,
  showStateLabels,
  showCbsaLabels,
  enableTooltip,
  enableMapNavigation,
  enableMouseTracking,
  mapHeight = '70vh',
  mapWidth = '',
  dynamicMapTitle,
  dynamicMapLevelWeek,
  mapTitleDisable,
  mapType,
  enableButtons = false,
  zoomLocation,
  chartRef,
  JsonData,
  stateJson,
  cbsaJson,
  zip3Json,
  zip3Data,
  activeZip3Data,
  showZip3Labels = true,
  toggleEnabled,
  mapDataType,
  highlightCBSA = false,
  exportMap = false,
  countyGeoJson,
  dashboardType,
  countyData,
}) => {
  if (typeof Highcharts === 'object') {
    HighchartsMap(Highcharts)
  }
  const toggleRef = useRef(toggleEnabled);
  const sundayDate = dayjs().day(0).format('YYYY-MM-DD')
  const actualsDate = dayjs().day(-14).format('YYYY-MM-DD')
  const actualsDateCovid = dayjs().day(-1).format('YYYY-MM-DD')
  const nowcastDate = dayjs().day(-7).format('YYYY-MM-DD')
  const { displayDate, regionSelected, displayWeek, dataSelected } =
    useGeoState()
    if (exportMap) {
    Exporting(Highcharts)
    OfflineExport(Highcharts)
  }
  const history = useHistory()
  useEffect(() => {
      toggleRef.current = toggleEnabled
  },[toggleEnabled])

  let mapActiveCbsaData = null
  let mapActiveZIP3Data = null
  let mapStatesData = null
  let mapCbsaData = null
  let mapMsaData = null
  let zip3DataFiltered = null
  let statesDataForDisplayDate = null

  if (mapType !== undefined && mapType.toUpperCase() === 'CIACCURACY') {
    const statesDataForDisplayDate = Object.entries(statesData['ENSEMBLE'])
    mapStatesData = statesDataForDisplayDate.map((state) => {
      return {
        value: state[1].OVERALL[mapOptions.value],
        mape: state[1].OVERALL[mapOptions.mapeValue],
        mae: state[1].OVERALL[mapOptions.maeValue],
        rmse: state[1].OVERALL[mapOptions.rmseValue],
        mase: state[1].OVERALL[mapOptions.maseValue],
        state: state[0],
        ...state[1].OVERALL,
      }
    })

    if (regionSelected === 'msa' && cbsaData) {
      const cbsaDataForDisplayDate = Object.entries(cbsaData['ENSEMBLE'])
      mapCbsaData = cbsaDataForDisplayDate.map((metro) => {
        return {
          value: metro[1].OVERALL[mapOptions.value],
          mape: metro[1].OVERALL[mapOptions.mapeValue],
          mae: metro[1].OVERALL[mapOptions.maeValue],
          rmse: metro[1].OVERALL[mapOptions.rmseValue],
          mase: metro[1].OVERALL[mapOptions.maseValue],
          cbsa: metro[0],
          ...metro[1].OVERALL,
        }
      })

      mapActiveCbsaData = activeCbsasData.map((cbsa) => {
        return cbsa.toString()
      })
    }
  } else if (mapType !== undefined && mapType.toUpperCase() === 'COVIDACC') {
    const statesDataForDisplayDate = Object.entries(statesData['ENSEMBLE'])
    mapStatesData = statesDataForDisplayDate.map((state) => {
      return {
        value:
          dataSelected === 'revised_accuracy'
            ? state[1].OVERALL[mapOptions.value]
            : state[1].OVERALL[mapOptions.value],
        mape:
          dataSelected === 'revised_accuracy'
            ? state[1].OVERALL[mapOptions.mapeValue]
            : state[1].OVERALL[mapOptions.mapeValue],
        mae:
          dataSelected === 'revised_accuracy'
            ? state[1].OVERALL[mapOptions.maeValue]
            : state[1].OVERALL[mapOptions.maeValue],
        rmse:
          dataSelected === 'revised_accuracy'
            ? state[1].OVERALL[mapOptions.rmseValue]
            : state[1].OVERALL[mapOptions.rmseValue],
        mase:
          dataSelected === 'revised_accuracy'
            ? state[1].OVERALL[mapOptions.maseValue]
            : state[1].OVERALL[mapOptions.maseValue],
        state: state[0],
        ...state[1].OVERALL,
      }
    })

    if (regionSelected === 'msa' && cbsaData) {
      const cbsaDataForDisplayDate = Object.entries(cbsaData['ENSEMBLE'])

      mapCbsaData = cbsaDataForDisplayDate.map((metro) => {
        return {
          value:
            dataSelected === 'revised_accuracy'
              ? metro[1].OVERALL[mapOptions.value]
              : metro[1].OVERALL[mapOptions.value],
          mape:
            dataSelected === 'revised_accuracy'
              ? metro[1].OVERALL[mapOptions.mapeValue]
              : metro[1].OVERALL[mapOptions.mapeValue],
          mae:
            dataSelected === 'revised_accuracy'
              ? metro[1].OVERALL[mapOptions.maeValue]
              : metro[1].OVERALL[mapOptions.maeValue],
          rmse:
            dataSelected === 'revised_accuracy'
              ? metro[1].OVERALL[mapOptions.rmseValue]
              : metro[1].OVERALL[mapOptions.rmseValue],
          mase:
            dataSelected === 'revised_accuracy'
              ? metro[1].OVERALL[mapOptions.maseValue]
              : metro[1].OVERALL[mapOptions.maseValue],
          cbsa: metro[0],
          ...metro[1].OVERALL,
        }
      })

      mapActiveCbsaData = activeCbsasData.map((cbsa) => {
        return cbsa.toString()
      })
    }
  } else if (mapType !== undefined && mapType.toUpperCase() === 'VUL') {
    const statesDataForDisplayDate = Object.entries(vulStateData.StateMapModel)
    //const statesDataForDisplayDate = Object.entries(statesData[displayDate])
    mapStatesData = statesDataForDisplayDate.map((state) => {
      return {
        value: state[1].Projected_Pct,
        state: state[1].Pat_Statecode.toUpperCase(),
        ...state[1],
      }
    })
  } else if (mapType !== undefined && mapType.toUpperCase() === 'COVERAGEMAP') {
    const stateDateData = Object.entries(statesData[sundayDate])
    mapStatesData = stateDateData.map((state) => {
      return {
        value: state[1].MR[mapOptions.value],
        state_per: state[1].MR[mapOptions.value],
        state_count: state[1].MR[mapOptions.stateCount],
        mr: state[1].MR[mapOptions.lobValue],
        mr_per: state[1].MR[mapOptions.lobPer],
        ei: state[1].EI[mapOptions.lobValue],
        ei_per: state[1].EI[mapOptions.lobPer],
        cs: state[1].CS[mapOptions.lobValue],
        cs_per: state[1].CS[mapOptions.lobPer],
        population: CountingMethod(state[1].MR[mapOptions.popCount], 'fixed'),
        state: state[0],
        ...state[1].MR,
      }
    })
  } else if (mapType !== undefined && mapType.toUpperCase() === 'ZIP3MAP') {
    var datacount = Object.keys(statesData).length - 1
    let lastData = Object.keys(statesData)[datacount]
    if (displayDate > lastData) {
      statesDataForDisplayDate = Object.entries(usStateDummy)
    } else {
      statesDataForDisplayDate = Object.entries(statesData[displayDate])
    }

    mapStatesData = statesDataForDisplayDate.map((state) => {
      const value = (state[1] !== null || undefined) 
                    ? state[1][mapOptions.value] : undefined // Get the value from the state
      const dataClass = mapOptions.colorAxis.dataClasses[value]

      return {
        value: (state[1] !== null || undefined) ? state[1][mapOptions.value] : undefined,
        state: state[0],
        borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff',
        // borderColor:  mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,
        ...state[1],
      }
    })

    if (mapType === 'ZIP3MAP' && zip3Data && !isEmptyObject(zip3Data)) {
      mapActiveZIP3Data = (activeZip3Data ?? []).map((zip3) =>
        String(zip3).padStart(3, '0')
      )
      const src = zip3Data[displayDate] ?? {}
      //const zip3DataForDisplayDate = Object.entries(zip3Data[displayDate])

      // zip3DataFiltered = zip3DataSortedEntries.map((state) => {
      // const value = state[1][mapOptions.value];
      // const dataClass = mapOptions.colorAxis.dataClasses[value];
      //   return {
      //     value: state[1][mapOptions.value],
      //     geoid: String(state[0]).padStart(3, '0'),
      //     borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff',
      //   // borderColor: mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,
      //     ...state[1],
      //   }
      // })

      zip3DataFiltered = (mapActiveZIP3Data ?? []).map((key) => {
        //const key = String(k).padStart(3, '0')
        const obj = src[key] ?? src[String(Number(key))]

        if (!obj) {
          return { geoid: key, value: null, borderColor: '#e0d4d4ff' }
        }

        const value = obj?.[mapOptions.value]
        const dataClass = mapOptions.colorAxis.dataClasses[value]
        return {
          value: obj?.[mapOptions.value],
          geoid: key, zip3:key,
          borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff',
          // borderColor: mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,
          ...obj,
        }
      })
    }
  } else if (
    mapType !== undefined &&
    (mapType.toUpperCase() === 'RSVMAP' ||
      mapType.toUpperCase() === 'RSVMAPMSA' ||
      mapType.toUpperCase() === 'FLUMAP' ||
      mapType.toUpperCase() === 'RSVMAPCDO')
  ) {
    statesDataForDisplayDate = Object.entries(statesData?.[displayDate] ?? [])   
    mapStatesData = statesDataForDisplayDate.map((state) => {    
       const value = (state[1] !== null || undefined) ? 
                     state[1][mapOptions.value] : undefined; // Get the value from the state
       const dataClass = mapOptions.colorAxis.dataClasses[value];
      
      return {
        value: (state[1] !== null || undefined) ? state[1][mapOptions.value] : undefined,
        state: state[0],
        geoid: state[0],
        borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff', // Use default color if dataClass is undefined 
     // borderColor:  mapOptions.colorAxis.dataClasses[state[1][mapOptions.value]].plotBorderColor,       
        ...state[1],    
      }
    })

    if (cbsaData && !isEmptyObject(cbsaData)) {
      const cbsaDataForDisplayDate = Object.entries(cbsaData[displayDate])
    
    mapCbsaData = cbsaDataForDisplayDate.map((cbsa) => {
    const value = (cbsa[1] != null || undefined) ? 
                  cbsa[1][mapOptions.value] : undefined // Get the value from the state
    const dataClass = mapOptions.colorAxis.dataClasses[value];
      return {
        value: (cbsa[1] != null || undefined) ?
                cbsa[1][mapOptions.value] : undefined,
        state: cbsa[0].toString(),
        cbsa: cbsa[0].toString(),
        borderColor: dataClass ? dataClass.plotBorderColor : '#e0d4d4ff', 
        //borderColor: mapOptions.colorAxis.dataClasses[cbsa[1][mapOptions.value]].plotBorderColor,
        
        ...cbsa[1],
      }
    })
    mapActiveCbsaData = activeCbsasData.map((cbsa) => {
      return cbsa.toString()
    })
    }
  } else if (mapType !== undefined) {
    const statesDataForDisplayDate = Object.entries(
      statesData[displayDate] ?? []
    )
    mapStatesData = statesDataForDisplayDate.map((state) => {
      let key_arr = ['epi_period_week', 'epi_period_year', 'epi_season']
      const value = (state[1] !== null || undefined) ? 
                     state[1][mapOptions.value] : undefined;  
      const dataClass = mapOptions.colorAxis.dataClasses[value];

      return {
        value: value,
        dataSelected: dataSelected,
        borderColor:
          key_arr.indexOf(state[0]) !== -1
            ? ''
            : dataClass ? dataClass.plotBorderColor : '#e0d4d4ff',                
        state: state[0],
        ...state[1],
      }
    })

    if (regionSelected === 'metro' || (regionSelected === 'msa' && cbsaData)) {
      let key_arr = ['epi_period_week', 'epi_period_year', 'epi_season']
      const cbsaDataForDisplayDate = Object.entries(cbsaData[displayDate])
      mapCbsaData = cbsaDataForDisplayDate.map((cbsa) => {
        return {
          value: cbsa[1][mapOptions.value],
          dataSelected: dataSelected,
          borderColor:
            key_arr.indexOf(cbsa[0]) !== -1
              ? ''
              : mapOptions.colorAxis.dataClasses[cbsa[1][mapOptions.value]]
                  .plotBorderColor,
          cbsa: cbsa[0].toString(),
          ...cbsa[1],
        }
      })

      mapActiveCbsaData = activeCbsasData.map((cbsa) => {
        return cbsa.toString()
      })
    }
    if (regionSelected === 'msa' && msaData) {
      const cbsaDataForDisplayDate = Object.entries(msaData[displayDate])
      mapMsaData = cbsaDataForDisplayDate.map((cbsa) => {
        return {
          value: cbsa[1][mapOptions.value],
          dataSelected: dataSelected,
          cbsa: cbsa[0].toString(),
          ...cbsa[1],
        }
      })
    }
  }

  let title = mapOptions.mapTitle
  if (!(title === null || title === undefined)) {
    let regionString = ''
    switch (regionSelected) {
      case 'state':
        regionString = 'States'
        break
      case 'metro':
        regionString = 'States + Metro Areas'
        break
      case 'msa':
        regionString = 'States + CBSA'
        break
      case 'county':
        regionString = 'Counties'
        break
      case 'zip3':
        regionString = 'States + Zip3'
        break
      default:
        regionString = ''
    }

    //added
    if (dynamicMapTitle === true && mapType === 'COVIDMAP') {
      if (displayDate <= actualsDateCovid) {
        title = title + ' - Actuals'
      } else {
        title = title + ' - Forecast'
      }
    } else if (dynamicMapTitle === true && mapType === 'FLUMAP') {
      // if (displayDate === nowcastDate) {
      //   title = title + ' Forecast for ' + regionString
      // } else if (displayDate < actualsDate) {
      //   // title = title + ' Actuals for ' + regionString
      //   title = 'Influenza Levels - Actual'
      // } else {
      //   //title = title + ' Forecast for 2' + regionString
      //   title = 'Influenza Levels - Forecasted'
      // }
    } else if (dynamicMapTitle === true && mapType === 'HeatMap') {
      title = title + ' Forecast for ' + regionString
    } else if (dynamicMapTitle === true && mapType === 'CIACCURACY') {
      title = 'Flucast Accuracy Heat Map'
    } else if (dynamicMapTitle === true && mapType === 'COVIDACC') {
      title = 'Covid Accuracy Heat Map'
    } 
    // else {
    //   title = title + ' for ' + regionString
    // }

    if (dynamicMapLevelWeek === true) {
      if (displayDate < actualsDate) {
        title =
          'Flu Actuals for ' +
          moment(displayDate).format('MMMM D, YYYY') +
          ' (Epiweek ' +
          displayWeek +
          ')'
      } else {
        title =
          'Flu Forecast for ' +
          moment(displayDate).format('MMMM D, YYYY') +
          ' (Epiweek ' +
          displayWeek +
          ')'
      }
    }
    if (mapTitleDisable === true) {
      title = ''
    }
  }

  const graphOptions = getMapOptions(
    mapOptions.colorAxis,
    mapOptions.legend,
    toolTipFormatter,
    mapActiveCbsaData,
    mapCbsaData,
    mapStatesData,
    mapMsaData,
    history,
    title,
    mapOptions.mapSubTitle,
    showStateLabels,
    enableTooltip,
    enableMapNavigation,
    enableMouseTracking,
    mapType,
    enableButtons,
    stateJson,
    cbsaJson,
    zip3Json,
    zip3DataFiltered,
    mapActiveZIP3Data,
    false,
    false,
    false,
    (showZip3Labels = true),
    true,
    zoomLocation,
    chartRef,
    () => toggleRef.current,
    mapDataType,
    JsonData,
    countyData,
    countyGeoJson,
    dashboardType,
    showCbsaLabels
  )

  return mapOptions ? (
       <HighchartsReact
        containerProps={{
          style: {
            height: mapHeight,
            width: mapWidth,
            position: 'relative',
            display: 'flex',
          },
        }}
        constructorType="mapChart"
        highcharts={Highcharts}
        options={graphOptions}
        allowChartUpdate
        updateArgs={[true, true, false]}
        ref={chartRef}
      />
  ) : (
    <Spinner />
  )
}

function isEmptyObject(obj) {
  return JSON.stringify(obj) === '{}'
}
export default Map
